import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { StaticServeModule } from '@core/static-serve/static-serve.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAvailableCardThemes } from '@pages/mobucks/state/banking.selectors';
import { GlobalState } from '@core/global-state/app.reducer';
import { TranslateModule } from '@ngx-translate/core';
import { ChooseCardUpcomingComponent } from '@pages/parents/pages/onboarding/components/choose-card-upcoming/choose-card-upcoming.component';

@Component({
  selector: 'mdk-select-cards-theme',
  standalone: true,
  imports: [CommonModule,NgOptimizedImage,StaticServeModule,DirectivesModule,PipesModule,TranslateModule,ChooseCardUpcomingComponent],
  templateUrl: './select-cards-theme.component.html',
  styleUrls: ['./styles/select-cards-theme.component.mobile.scss','./styles/select-cards-theme.component.desktop.scss']
})
export class SelectCardsThemeComponent implements OnInit, OnDestroy {


  //#region [---- INPUTs & OUTPUTs ----]

  @Input() imagesIdentifiers: string[];
  @Input() title: string;
  @Input() note: string;
  @Output() cardThemeSelected: EventEmitter<string> = new EventEmitter<string>();

  //#endregion

  //#region [---- DEPENDENCIES ----]

  private readonly store: Store<GlobalState> =inject(Store<GlobalState>)

  //#endregion

  //#region [---- PROPERTIES ----]

  private readonly cardThemesSubscription: Subscription =
  new Subscription();

  //#endregion

  //#region [---- LIFE CYCLES ----]

  ngOnInit(): void {
    if(!this.imagesIdentifiers?.length) this.getIdentifiersFromStore()
  }

  ngOnDestroy(): void {
    this.cardThemesSubscription.unsubscribe()
  }

  //#endregion

  //#region [---- LOGIC ----]

  private getIdentifiersFromStore():void{
    this.cardThemesSubscription.add(
      this.store.select(selectAvailableCardThemes).subscribe({
        next: (themes) => {
          if(!this.imagesIdentifiers?.length && themes?.length) this.imagesIdentifiers = themes
        },
      })
    );
  }

  public onSelectedTheme(theme:string):void{
    this.cardThemeSelected.emit(theme)
  }

  //#endregion


}